module.exports = __webpack_public_path__ + "img/query.adbbc00d.svg";